import { render } from "./GameMast.vue?vue&type=template&id=70b8a332"
import script from "./GameMast.vue?vue&type=script&lang=js"
export * from "./GameMast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__